import { Map } from 'immutable';
import { combineReducers } from 'redux';
import {
  FETCH_CATEGORY_META_DATA,
  FETCH_CATEGORY_META_DATA_SUCCESS,
  FETCH_CATEGORY_META_DATA_FAIL,
} from '../actions/actionTypes';

const initialState = Map();

const items = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_CATEGORY_META_DATA_SUCCESS: {
      return state.mergeDeep(payload);
    }

    default:
      return state;
  }
};

function request(state = initialState, { type, error, meta }) {
  switch (type) {
    case FETCH_CATEGORY_META_DATA: {
      const next = {[meta.url]: { status: 'LOADING' }};
      return state.merge(next);
    }
    
    case FETCH_CATEGORY_META_DATA_SUCCESS: {
      const next = {[meta.url]: { status: 'SUCCESS', statusCode: 200 }};
      return state.merge(next);
    }
    
    case FETCH_CATEGORY_META_DATA_FAIL: {
      const next = {[meta.url]: { status: 'ERROR', statusCode: error.response.status }};
      return state.merge(next);
    }
    
    default:
      return state;
  }
}

export default combineReducers({
  items,
  request
});



// WEBPACK FOOTER //
// ./src/reducers/categories.js